import "./FormCheckbox.scss";
import Checkbox from "@mui/material/Checkbox";
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
interface FormCheckboxProps {
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
  checked: boolean;
  name?: string;
}
const FormCheckbox = ({ onChange, checked, name }: FormCheckboxProps) => {
  return (
    <Checkbox
      icon={<PanoramaFishEyeIcon fontSize={'large'}/>}
      checkedIcon={<CheckCircleIcon fontSize={'large'}/>}
      className="form-checkbox"
      checked={checked}
      onChange={onChange}
      name={name}
    />
  );
};

export default FormCheckbox;
